'use client';

import { useSetAtom } from 'jotai';
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';

import { languageAlternatesAtom } from '@packages/modules/src/Header/MetaNavigation/shared/useLocaleSwitch.atom';

export const ContentEffects = ({ alternateLinks }: { alternateLinks?: Record<string, string> }) => {
  const pathname = usePathname();
  const setLanguageAlternates = useSetAtom(languageAlternatesAtom);

  useEffect(() => {
    setLanguageAlternates({
      currentPathname: pathname ?? 'unknown',
      alternateLinks,
    });
  }, [alternateLinks, pathname, setLanguageAlternates]);

  return null;
};
